import { IsNotEmpty } from 'class-validator';
import { EpimsBaseEntityDto } from './epim-base.dto';

export class GroupDto extends EpimsBaseEntityDto {

  @IsNotEmpty()
  GroupName: string;
  length: number;
}
